// @flow
import * as React from 'react';
import SailIcon from 'sail/Icon';
import type {IconType, IconColor} from 'sail/Icon/types';

type IconProps = {|
  type: IconType,
  color: IconColor,
  alt?: string,
  size?: number,
|};

export const Icon = ({type, color, size, alt}: IconProps) => {
  return (
    <SailIcon
      icon={type}
      color={color}
      aria-hidden={!alt}
      alt={alt || undefined}
      size={size}
      style={{display: 'inline'}}
    />
  );
};
